const AGENT_PENALTY_PERCENT = 120
const PENALTY_CREDIT_HOLD_HOURS = 48
const PENALTY_CREDIT_HOLD_MS = PENALTY_CREDIT_HOLD_HOURS * 60 * 60 * 1000

function calculateAgentPenaltyAmount (ticketAmountCents) {
  const ticketAmount = Math.abs(Number(ticketAmountCents) || 0)
  return Math.round(ticketAmount * AGENT_PENALTY_PERCENT / 100)
}

function penaltyCreditAvailableAt (dateCreated) {
  const created = new Date(dateCreated)
  return new Date(created.getTime() + PENALTY_CREDIT_HOLD_MS)
}

function penaltyCreditReleasedBefore (now) {
  const current = now ? new Date(now) : new Date()
  return new Date(current.getTime() - PENALTY_CREDIT_HOLD_MS)
}

module.exports = {
  AGENT_PENALTY_PERCENT,
  PENALTY_CREDIT_HOLD_HOURS,
  calculateAgentPenaltyAmount,
  penaltyCreditAvailableAt,
  penaltyCreditReleasedBefore
}
